<template>
  <div>
    <Line id="line-chart" :options="chartOptions" :data="chartData" :height="heightLine" />
  </div>
</template>
  <script>
import {Line} from "vue-chartjs";
import {Chart as ChartJS, Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement, Filler} from "chart.js";
import {numeric} from "@vuelidate/validators";
ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement, Filler);
export default {
  name: "LineCharts",
  components: {Line},
  props: {
    chartData: {
      type: Object,
      default: {},
    },
    heightLine: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        lineTension: 0,
        maintainAspectRatio: false,
        scales: {
          y: {
            ticks: {
              precision: 0,
            },
          },
        },
        plugins: {
          legend: {
            labels: {
              usePointStyle: true,
              boxHeight: 6,
            },
            align: "end",
          },
        },
        tooltips: {
          enabled: false,
        },
      },
    };
  }
};
</script>
  